import React from 'react'
import { withTranslation } from 'react-i18next'

const PrivacyPolicy = ({ t }) => {
    return (
        <div className="policy-page">
            <h1>{t('_pages._privacy_policy.title')}</h1>
            <h3>{t('_pages._privacy_policy.last_updated')}</h3>
            <br />
            <br />
            <br />
            <p>
                {t('_pages._privacy_policy.text_1_1')} <a href="/">Interacty.me</a>{' '}
                {t('_pages._privacy_policy.text_1_2')}.
            </p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.users_personal_info')}</h2>
            <p>{t('_pages._privacy_policy.text_2')}</p>
            <br />
            <br />
            <p>{t('_pages._privacy_policy.text_3')}</p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.cookies')}</h2>
            <p>{t('_pages._privacy_policy.text_4')}</p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.data_collects_users')}</h2>
            <p>{t('_pages._privacy_policy.text_5')}</p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.data_collects_creators')}</h2>
            <p>{t('_pages._privacy_policy.text_6')}</p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.data_collects_visitors')}</h2>
            <p>
                {t('_pages._privacy_policy.text_7_1')} <a href="/">Interacty.me</a>{' '}
                {t('_pages._privacy_policy.text_7_2')}
            </p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.data_protection')}</h2>
            <p>{t('_pages._privacy_policy.text_8')}</p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.social_media')}</h2>
            <p>{t('_pages._privacy_policy.text_9')}</p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.other_uses')}</h2>
            <p>
                {t('_pages._privacy_policy.text_10_1')}{' '}
                <a href="https://aws.amazon.com/ru/service-terms/">https://aws.amazon.com/ru/service-terms/</a>{' '}
                {t('_pages._privacy_policy.text_10_2')}{' '}
                <a href="https://aws.amazon.com/ru/privacy/">https://aws.amazon.com/ru/privacy/</a>.{' '}
                {t('_pages._privacy_policy.text_10_3')}{' '}
                <a href="https://aws.amazon.com/compliance/gdpr-center/">
                    https://aws.amazon.com/compliance/gdpr-center/
                </a>
                ). {t('_pages._privacy_policy.text_10_4')}{' '}
                <a href="https://tools.google.com/dlpage/gaoptout?hl=en">
                    https://tools.google.com/dlpage/gaoptout?hl=en
                </a>
                . {t('_pages._privacy_policy.text_10_5')} (
                <a href="https://www.google.com/analytics/terms">https://www.google.com/analytics/terms</a>),{' '}
                {t('_pages._privacy_policy.text_10_6')} (
                <a href="http://www.google.com/intl/de/analytics/learn/privacy.html">
                    http://www.google.com/intl/de/analytics/learn/privacy.html
                </a>
                ) {t('_pages._privacy_policy.text_10_7')} (
                <a href="www.google.de/intl/de/policies/privacy">www.google.de/intl/de/policies/privacy</a>).{' '}
                {t('_pages._privacy_policy.text_10_8')}
            </p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.deleting_user_data')}</h2>
            <p>
                {t('_pages._privacy_policy.text_11')} <a href="mailto:support@interacty.me">support@interacty.me</a>.
            </p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.service_email_communications')}</h2>
            <p>
                {t('_pages._privacy_policy.text_12_1')} <a href="mailto:support@interacty.me">support@interacty.me</a>.{' '}
                {t('_pages._privacy_policy.text_12_2')}
            </p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.use_infants')}</h2>
            <p>
                {t('_pages._privacy_policy.text_13')} <a href="mailto:support@interacty.me">support@interacty.me</a>.
            </p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.policy_changes')}</h2>
            <p>{t('_pages._privacy_policy.text_14')}</p>
            <br />
            <br />
            <h2>{t('_pages._privacy_policy.suggestions')}</h2>
            <p>
                {t('_pages._privacy_policy.text_15')} <a href="mailto:info@interacty.me">info@interacty.me</a>.
            </p>
            <br />
            <br />
        </div>
    )
}

export default withTranslation('translations')(PrivacyPolicy)
